<template>
  <NuxtLink
    v-if="isLink"
    v-slot="{ href }"
    :to="{ path: link }"
    class="button button--reverse"
    custom
  >
    <a @click="handleLinkClick(href)">
      <i class="icon">
        <slot />
      </i>
      <span>
        {{ label }}
      </span>
    </a>
  </NuxtLink>
  <div
    v-else
    :class="{ active: isActive }"
    class="button button--reverse"
    @click="emitClick"
  >
    <i class="icon">
      <slot />
    </i>
    <span>
      {{ label }}
    </span>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  isActive?: boolean
  isLink?: boolean
  label?: string
  link?: string
}>()
const emits = defineEmits(['onClick'])

function emitClick() {
  emits('onClick')
}

function handleLinkClick(href: string) {
  navigateTo(href)
  emitClick()
}
</script>

<style lang="less" scoped>
.button {
  .flex();
  .justify-start();
  .text-center();
  .flex-col();

  height: @mobile-secondary-nav-height;
  padding: @gutter-xs 0 0;
  width: 100%;

  .icon {
    .font-lg();

    min-height: @27px;
    color: @color-text;

    & + span {
      .font-size(12, 18);

      padding: 0;
    }
  }

  &:hover,
  &.active {
    background-color: @color-fill-normal;
  }
}
</style>
